import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._col = null
    this._asc = true
    this._allThs().forEach(th => th.appendChild(this._makeIcon("⇅", "sort-icon ms-1 text-muted opacity-50")))
  }

  sort(event) {
    const th = event.currentTarget
    const allThs = this._allThs()
    const col = allThs.indexOf(th)

    if (this._col === col) {
      this._asc = !this._asc
    } else {
      this._col = col
      this._asc = true
    }

    allThs.forEach(h => {
      const icon = h.querySelector(".sort-icon")
      if (icon) icon.remove()
      h.appendChild(this._makeIcon("⇅", "sort-icon ms-1 text-muted opacity-50"))
    })
    th.querySelector(".sort-icon").remove()
    th.appendChild(this._makeIcon(this._asc ? "▲" : "▼", "sort-icon ms-1 text-primary"))

    const tbody = this.element.querySelector("tbody")
    const rows = Array.from(tbody.querySelectorAll("tr"))

    rows.sort((a, b) => {
      const aVal = a.querySelectorAll("td")[col]?.dataset.sortValue ?? ""
      const bVal = b.querySelectorAll("td")[col]?.dataset.sortValue ?? ""
      const aNum = parseFloat(aVal)
      const bNum = parseFloat(bVal)
      const result = (!isNaN(aNum) && !isNaN(bNum))
        ? aNum - bNum
        : aVal.localeCompare(bVal)
      return this._asc ? result : -result
    })

    rows.forEach(row => tbody.appendChild(row))
  }

  _allThs() {
    return Array.from(this.element.querySelectorAll("thead th"))
  }

  _makeIcon(text, className) {
    const span = document.createElement("span")
    span.className = className
    span.textContent = text
    return span
  }
}
